<template>
  <div>
    <div class="scroll">
      <div />
      <table class="table">
        <thead>
          <tr>
            <td class="head__column">案件</td>
            <td class="head__column">期間</td>
            <td class="head__column">予算</td>
            <td class="head__column">消化金額</td>
            <td class="head__column">残り予算</td>
            <td class="head__column">進捗消化率</td>
            <td class="head__column">残り日数</td>
            <td class="head__column">前日消化金額</td>
            <td class="head__column">前日消化割合</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="IO in table" :key="IO.insertionOrderId" class="io__row">
            <td class="io__column">
              <v-radio-group :value="radios" :mandatory="false">
                <v-radio
                  @change="changeChart({ IOId: IO.insertionOrderId })"
                  :label="`${IO.insertionOrder}（${IO.insertionOrderId}）`"
                  :value="IO.insertionOrderId"
                  color="blue"
                />
              </v-radio-group>
            </td>
            <td class="io__column io__column--BPSelector">
              <BPSelector :bpIds="IO.BPIds" :ioId="IO.insertionOrderId" />
            </td>
            <td class="io__column">
              {{ IO.insertionOrderBudget | budgetFormat }}
            </td>
            <td class="io__column">
              {{ IO.revenueBuyingCurrency | revenueBuyingCurrencyFormat }}
            </td>
            <td class="io__column">
              <div v-if="IO.remainingBudget === null">
                <span>¥0</span>
              </div>
              <div v-else>
                {{ IO.remainingBudget | budgetFormat }}
              </div>
            </td>
            <td class="io__column">
              <AppPercent
                :value="IO.insertionOrderBudgetProgress * 100"
                integer
              />
            </td>
            <td class="io__column">
              <div v-if="IO.remainingDays === null">
                <span>-</span>
              </div>
              <div v-else>
                {{ IO.remainingDays }}
              </div>
            </td>
            <td class="io__column">
              <div v-if="IO.yesterdayBuyingCurrency <= 0">
                <span>-</span>
              </div>
              <div v-else>
                {{ IO.yesterdayBuyingCurrency | budgetFormat }}
              </div>
            </td>
            <td class="io__column">
              <div v-if="IO.yesterdayBuyingCurrency === null">
                <span>-</span>
              </div>
              <div v-else>
                <AppPercent :value="IO.yesterdayBudgetProgress * 100" integer />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import BudgetProgressReportAPI from '@/api/BudgetProgressReport/BudgetProgressReport'
import BPSelector from '@/components/Advertiser/Report/BudgetProgressReport/BPSelector'
import { actions, getters } from '@/vuex/modules/progressReport/constants'
import {
  clicksFormat,
  impsFormat,
  revenueBuyingCurrencyFormat,
  budgetFormat,
  ctrFormat,
  cpcFormat,
} from '@/middlewares/numberFormat'

export default {
  name: 'Table',
  components: { BPSelector },
  filters: {
    clicksFormat,
    impsFormat,
    revenueBuyingCurrencyFormat,
    budgetFormat,
    ctrFormat,
    cpcFormat,
  },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    middleLang: {
      type: Array,
      default: () => [],
    },
    bpList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    radios() {
      return this.$store.getters[getters.selectedIOId]
    },
    table() {
      return BudgetProgressReportAPI.mergeData({
        tableData: this.tableData,
        middleLang: this.middleLang,
        BPList: this.$store.getters[getters.BPList],
      })
    },
  },
  methods: {
    changeChart({ IOId }) {
      this.$store.dispatch(actions.CHANGE_CHART, {
        IOId: IOId,
        advertiserId: this.$route.params.advertiserId,
      })
    },
  },
}
</script>

<style scoped lang="scss">
.scroll {
  overflow-y: scroll;
  height: 300px;
}

.table {
  border-collapse: collapse;
  width: 100%;
  margin-bottom: 20px;
}

.head {
  &__column {
    padding: 5px 10px;
    font-weight: normal;
    background: #ffffff;
    white-space: nowrap;
    user-select: none;
    line-height: 2;
    position: sticky;
    top: 0;
    z-index: 1;
  }
}

.io {
  &__column {
    text-align: right;
    padding: 5px 10px;
    border-width: 1px;
    border-style: solid;
    border-color: gray transparent;
    font-weight: normal;
    white-space: nowrap;
    background: #d9e3f1;

    &:first-child {
      border-color: gray transparent gray gray;
    }

    &:last-child {
      border-color: gray gray gray transparent;
    }

    &--BPSelector {
      padding: 0;
    }

    &--clickable {
      cursor: pointer;
    }

    &--center {
      text-align: center;
    }
  }

  &__arrow-icon {
    vertical-align: middle;

    &__turn {
      transform: rotate(90deg);
    }
  }
}

.pointer {
  cursor: pointer;
}

.active {
  text-decoration: underline;
  text-decoration-color: gray;
}

.reverse {
  transform: scale(1, -1);
}

.none {
  display: none;
}

.campaign-sort {
  font-weight: normal;
  margin-right: 10px;
}
</style>
